export default {
  currentPage: state => state.currentPage,
  currentMode: state => state.currentMode,
  currentActiveMenu: state => state.currentActiveMenu,
  getMenu: state => state.menu,
  getSuspendedMenu: state => state.suspendedMenu
};
